export default __webpack_public_path__ + "412f51e53ff8dc9ec4ef4b8a1efd7ce7.png";